import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Box, Button } from "@mui/material";

import AthletesCSV from "./components/AthletesCSV";
import ImportRaces from "./components/ImportRaces";
import ListeForce from "./components/ListeForce";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login"; // Peut rester même si inutilisé

import { SettingsProvider } from "./context/SettingsContext";
import AthleteView from "./components/AthleteView";

function App() {
    return (
        <SettingsProvider>
            <Router>
                <Box sx={{ padding: 2 }}>

                    {/* Navigation toujours visible */}
                    <Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
                        <Button component={Link} to="/dashboard" variant="contained">
                            Dashboard
                        </Button>
                        <Button component={Link} to="/athletes" variant="contained">
                            Import Athlètes CSV
                        </Button>
                        <Button component={Link} to="/importraces" variant="contained">
                            Import Courses XML
                        </Button>
                        <Button component={Link} to="/listforce" variant="contained">
                            Liste de force
                        </Button>

                    </Box>

                    {/* Routes publiques */}
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/athlete" element={<AthleteView />} />


                            <Route path="/athlete/:noP" element={<AthleteView />} />

                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/athletes" element={<AthletesCSV />} />
                        <Route path="/importraces" element={<ImportRaces />} />
                        <Route path="/listforce" element={<ListeForce />} />

                        {/* Page d'accueil → Dashboard directement */}
                        <Route path="/" element={<Dashboard />} />
                    </Routes>
                </Box>
            </Router>
        </SettingsProvider>
    );
}

export default App;
